import { atom } from "recoil";
export const popupState = atom({
    key: "popupState",
    default: {
        isOpen: false,
        dimm: true,
        content: null,
        onCloseCallback: null, // 팝업 닫힘 시 실행될 콜백 함수
    },
});
export const proposalEditState = atom({
    key: "proposalEditState",
    default: {
        proposalType: null,
        proposalTypeName: "",
        proposalTypeId: null,
        pageName: "",
        pageInfo: null,
        pageSlide: [],
    },
});
